import {AlpineComponent} from 'alpinejs';
import Swiper from 'swiper';
import * as SwiperModules from 'swiper/modules';
import {PlayerEvents} from '../plugins/video-player/Player';

type MediaData = {}

export default (): AlpineComponent<MediaData> => ({
  init() {
    const swiperEl = this.$root.querySelector<HTMLElement>('.swiper');
    if (!swiperEl) {
      return;
    }
    new Swiper(swiperEl, {
      speed: 500,
      threshold: 10,
      watchOverflow: true,
      followFinger: true,
      modules: [SwiperModules.Navigation],
      navigation: {
        prevEl: this.$root.querySelector<HTMLElement>('.ce-media-btn--prev'),
        nextEl: this.$root.querySelector<HTMLElement>('.ce-media-btn--next')
      },
      on: {
        slideChange: (swiper) => {
          const video: HTMLVideoElement | null = swiper.slides[swiper.previousIndex]
            .querySelector<HTMLVideoElement>('.media-item');
          video?.closest('[x-video-player]')?.dispatchEvent(PlayerEvents.stop);
        },
        slidesLengthChange: () => {
          this.$lazyLoad.update();
        }
      }
    });
  }
});
